export default __webpack_public_path__ + "static/media/HappyGirlInCar.ff02ea48.webp";